const header = () => {
  window.addEventListener('scroll', () => {
    if (pageYOffset > 0) {
      document.querySelector('.js-header').classList.add('is-scrolled');
      document.querySelector('body').classList.add('is-scrolled');
    } else {
      document.querySelector('.js-header').classList.remove('is-scrolled');
      document.querySelector('body').classList.remove('is-scrolled');
    }
  });
};

export default header;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/kerris-select-chisel/src/scripts/modules/header.js